import { render } from "./gxxg.vue?vue&type=template&id=e5f3b310&scoped=true&ts=true"
import script from "./gxxg.vue?vue&type=script&lang=ts"
export * from "./gxxg.vue?vue&type=script&lang=ts"

import "./gxxg.vue?vue&type=style&index=0&id=e5f3b310&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5f3b310"]])

export default __exports__